import { DateTime } from "luxon";

export const sevenDaysFromX = (dateProp) => new Date(dateProp.setDate(dateProp.getDate() + 7));
export const afterSevenDaysToTwoMonthsDaysFromX = (dateProp) => new Date(dateProp.setDate(dateProp.getDate() + 60));

const today = DateTime.now().startOf("day");
const todayEnd = DateTime.now().endOf("day");
const yearsAllTime = new Date().getFullYear() - new Date("2023-05-01").getFullYear();
export const last_7_days = [today.minus({ days: 7 }), todayEnd];
export const last_30_days = [today.minus({ days: 30 }), todayEnd];
export const next_7_days = [today, todayEnd.plus({ days: 7 })];
export const next_30_days = [today, todayEnd.plus({ days: 30 })];

export const thisMonth = [today.startOf("month"), todayEnd];
const lastMonth = [
  today.minus({ months: 1 }).startOf("month"),
  todayEnd.minus({ months: 1 }).endOf("month"),
];
const nextMonth = [
  today.plus({ months: 1 }).startOf("month"),
  todayEnd.plus({ months: 1 }).endOf("month"),
];
const thisYear = [today.startOf("year"), todayEnd];
const lastYear = [
  today.minus({ years: 1 }).startOf("year"),
  todayEnd.minus({ years: 1 }).endOf("year"),
];
const allTime = [today.minus({ years: yearsAllTime }).startOf("year"), todayEnd];

function formatYearMonth(date) {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  return year + "-" + month;
}
export function getMonthYearsListfrom() {
  let monthAndYearList = [];

  let startDate = "2023-05-01";

  let createdDate = new Date(startDate);
  let currentDate = new Date();
  let dateAndYearList = [
    {
      month: createdDate.getMonth(),
      year: createdDate.getFullYear(),
      period: formatYearMonth(createdDate),
    },
  ];

  while (createdDate.setMonth(createdDate.getMonth() + 1) < currentDate) {
    dateAndYearList.push({
      month: createdDate.getMonth(),
      year: createdDate.getFullYear(),
      period: formatYearMonth(createdDate),
    });
  }

  for (let i = 0; i < dateAndYearList.length; i++) {
    monthAndYearList.unshift({
      name: dateAndYearList[i].period,
      id: dateAndYearList[i].period,
      value: getStartEndDate(dateAndYearList[i].year, dateAndYearList[i].month),
    });
  }
  return monthAndYearList;
}

export function getStartEndDate(year, month) {
  var today = new Date();
  today.setYear(year);
  today.setMonth(month);
  var date = DateTime.fromJSDate(today).startOf("day");
  return [
    date.startOf("month").toUTC().toString(),
    date.endOf("month").endOf("day").toUTC().toString(),
  ];
}
function getQuarter(flag) {
  var m = flag == "current" ? new Date().getMonth() : new Date().getMonth() - 3;
  var startdate = new Date();
  var enddate = new Date();
  var year = new Date().getFullYear() ;
  if (m < 0 ){
    m = 11;
    startdate.setFullYear(year - 1);
    enddate.setFullYear(year - 1);
  }

  if (m >= 0 && m <= 2) {
    startdate.setMonth(0);
    startdate.setDate(1);
    enddate.setMonth(2);
    flag == "current" ? enddate : enddate.setDate(31);
  } else if (m >= 3 && m <= 5) {
    startdate.setMonth(3);
    startdate.setDate(1);
    enddate.setMonth(5);
    flag == "current" ? enddate : enddate.setDate(30);
  } else if (m >= 6 && m <= 8) {
    startdate.setMonth(6);
    startdate.setDate(1);
    enddate.setMonth(8);
    flag == "current" ? enddate : enddate.setDate(30);
  } else if (m >= 9 && m <= 11) {
    startdate.setMonth(9);
    startdate.setDate(1);
    enddate.setMonth(11);
    flag == "current" ? enddate : enddate.setDate(31);
  }
  return [DateTime.fromJSDate(startdate).startOf('day'), DateTime.fromJSDate(enddate).endOf('day')];
}

export const DateRanges = {
  "This Month": thisMonth,
  "Last Month": lastMonth,
  // 'Today': [today, today],
  // 'Next Month': nextMonth,
  "This Quarter": getQuarter("current"),
  "Last Quarter": getQuarter("last"),
  "Last 30 Days": last_30_days,
  "This Year": thisYear,
  "Last Year": lastYear,
  "All Time": allTime,
};
